import { api } from '@/lib/api';

interface DashboardStats {
  totalWords: number;
  learnedWords: number;
  learningWords: number;
  practiceSessions: number;
  ratingDistribution: {
    "1": number;
    "2": number;
    "3": number;
    "4": number;
    "5": number;
  };
  recentWords: Array<{
    id: string;
    user_id: string;
    word_id: string;
    word: string;
    rating: number;
    is_learned: boolean;
    payload: any;
    source: string;
    created_at: string;
    updated_at: string;
    word_created_at: string;
    word_updated_at: string;
  }>;
  fillInTheBlankSessions: number;
}

interface DashboardResponse {
  ok: boolean;
  data: DashboardStats;
}

export const dashboardService = {
  /**
   * Get user learning statistics and progress
   */
  getUserStats: async (): Promise<DashboardStats> => {
    const response = await api.get<DashboardResponse>('/dashboard');
    return response.data;
  },
};